import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { GuestService } from '../services/guest.service';
import { LanguageCode } from '../Models/WidgetSettingsModels';
import { DEFAULT_LANGUAGE_ID } from '../constants/commonenums';


@Pipe({
  name: 'formatSettingsDate'
})
export class FormatSettingsDatePipe implements PipeTransform {
  constructor(private gs: GuestService){}

  transform(value: string | Date, format: string) {
    let localeValue = 'en';
    let language =  this.gs.getLanguageIdFromUrl();
    let localMoment = moment(value);
    if(language){
      localeValue = LanguageCode[language?.toLowerCase()]     
    }
    else {
      localeValue = this.gs.availableLanguages ? this.gs.findLocale(sessionStorage.getItem('languageId') || DEFAULT_LANGUAGE_ID) : localeValue;
    }

    if(localeValue == LanguageCode.chinesesimplified){
      var time = localMoment?.locale("zh-cn")?.format(format);
      time = time?.replace(/AM/g, "上午").replace(/PM/g, "下午");
      return time;
    }

    if(localeValue == LanguageCode.chinesetraditional){
      var time = localMoment?.locale("zh-tw")?.format(format);
      time = time?.replace(/AM/g, "上午").replace(/PM/g, "下午");
      return time;
    }

    return moment(new Date(value)).locale(localeValue).format(format.toUpperCase());
  }

}
